'use strict';

angular.module('mobile-apps')
	.directive('displayScreenshot',[
		'EntryMain',
		function(
			EntryMain
		) {
			return {
				scope:
				{
					data : '=', // The data to display
					clickCallback : '=', // Callback to call when clicked on image
					keyClickCallback : '=', // Callback to call when clicked on key
					activeKeys: '@', // The comma separated active keys
					// How the active and the other keys should be displayed:
					// - hidden: Do not display at all
					// - always: Display always
					// - screenshot-mouseover: Display when mouse is over screenshot
					// - field-mouseover: Display when mouse is over field
					activeDisplay: '@',
					otherDisplay: '@',
					overlayOverwrite: '=',
					// Optional buttons to add to overlays.
					// Example:
					// {
					//   ID: {
					//     name: 'Button Text',
					//     onClick: function(id, event) {
					//       ...
					//     }
					//   }
					// }
					screenshotScale: '@', // Defines how the screenshot gets displayed (optional):
					// - "-1": Original screenshot resolution
					// - ">0<-1": Screenshot gets displayed smaller as with "-1"
					// - "<-1": Screenshot gets displayed larger as with "-1"
					// - ">1": Screenshot gets displayed larger as with "1"
					// -  "1": Screenshot gets displayed as large as possible without
					//         displaying it larger than it is
					// - ">0<1": Screenshot gets displayed smaller as with "1"
					// - ">1": Screenshot gets displayed larger as with "1"
				},
				templateUrl: 'modules/mobile-apps/views/display-screenshot.client.view.html',
				link: function (scope, elem, attrs) {

					scope.overlays = [];
					scope._activeKeys = [];

					// Set the default display behaviour
					if (!scope.activeDisplay) {
						scope.otherDisplay = 'always';
					}
					if (!scope.otherDisplay) {
						scope.otherDisplay = 'hidden';
					}


					/**
					 * Gets called whenever a string field gets clicked on the screenshot
					 */
					var stringClicked = function(key, $event) {
						$event.stopPropagation();
						if (!scope.keyClickCallback || !angular.isFunction(scope.keyClickCallback)) {
							return;
						}

						// Get the full entry instance and only if we find one
						// we call the callback
						var entry = EntryMain.getEntryByKey(key);
						var hiddenEntry = EntryMain.getHiddenEntryDescByKey(key);

                        if (!entry && hiddenEntry) {
                            entry = hiddenEntry;
                        }

						if (!entry) {
							return;
						}

						scope.keyClickCallback(entry);
					};


					/**
					 * Sets the array with the overlays to be displayed
					 */
					function setOverlays() {
						if (scope.activeDisplay === 'hidden' && scope.otherDisplay === 'hidden') {
							return;
						}

						scope.isBlankScreenshot = scope.data.metaData.isBlank;

						// Add stringPositions if we have any to display them
						// on the screenshots
						scope.overlays.length = 0;

						if (scope.data && scope.data.metaData && scope.data.metaData.stringPositions && angular.isArray(scope.data.metaData.stringPositions)) {

							var overlayOverwrite = {};
							if (scope.overlayOverwrite && angular.isObject(overlayOverwrite)) {
								overlayOverwrite = scope.overlayOverwrite;
							}

							// Go through them one at a time and set the calculated
							// location
							scope.data.metaData.stringPositions.forEach(function(stringPosition) {

								var stringClass = '';
								var stringPositionKey = stringPosition.key || stringPosition.fuzzyKeys[0];
								if (scope._activeKeys.indexOf(stringPositionKey) !== -1) {
									// Is active key
									if (!scope.activeDisplay || scope.activeDisplay === 'hidden') {
										// Do not display the key
										return;
									}

									stringClass = scope.activeDisplay;
								} else {
									// Is other key
									if (scope.otherDisplay === 'hidden') {
										// Do not display the key
										return;
									}

									stringClass = scope.otherDisplay + ' other';
								}


								var overlayData = {
									key: stringPositionKey,
									isBlank: scope.isBlankScreenshot,
									position: {
										x: stringPosition.x,
										y: stringPosition.y,
										width: stringPosition.width,
										height: stringPosition.height
									},
									css: stringPosition.css,
									class: stringClass,
									onClick: stringClicked
								};

								if (overlayOverwrite.hasOwnProperty(stringPositionKey)) {
									for (var property in overlayOverwrite[stringPositionKey]) {
										overlayData[property] = overlayOverwrite[stringPositionKey][property];
									}
								}

								scope.overlays.push(overlayData);
							});

						}

					}

					// Update the displayed strings whenever the activeKeys change.
					// That always the correct strings get displayed.
					scope.$watch(function() {return scope.activeKeys; }, function() {
						scope._activeKeys.length = 0;
						if (scope.activeKeys) {
							scope._activeKeys.push(...scope.activeKeys.split('  -,-  '));
						}
						// Update the displayed strings
						setOverlays();
					});


					// Keep an eye on the data that we can update the overlays
					// whenever they need changing
					scope.$watch(function() {
						if (!scope.data) {
							return undefined;
						}
						return scope.data._id;
					}, function(newValue) {
						if (newValue) {
							setOverlays()
						}
					});


					// Check also if overlay overwrites get removed or added so
					// that the overlays got updated
					scope.$watch('overlayOverwrite', function(newValue) {
						setOverlays()
					}, true);


					/**
					 * If an optional callback got defined for clicking on
					 * screenshot it gets called
					 */
					scope.imageClicked = function() {
						if (scope.clickCallback) {
							scope.clickCallback(scope.data);
						}
					};

				}
			};
		}]);
